import { translate } from '~/core/translate'

import { ACTION_TYPES } from '~/core/constants'

const { CALENDAR } = ACTION_TYPES

const initialState = {
  syncingInProgress: true,
  isSynced: false,
  items: [],
  primaryProvider: '',
  profileName: ''
}

const getPrimaryCalendar = calendars => {
  const unknownStr = translate('unknown')

  const unknownCalendar = {
    providerName: unknownStr,
    name: unknownStr
  }

  return (
    calendars.find(calendar => calendar.primary) ||
    calendars[0] ||
    unknownCalendar
  )
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case CALENDAR.SYNCING_IN_PROGRESS: {
      return {
        ...state,
        syncingInProgress: action.payload
      }
    }
    case CALENDAR.SET_SYNCED: {
      return {
        ...state,
        isSynced: action.payload,
        syncingInProgress: false
      }
    }
    case CALENDAR.SET_CALENDAR_DATA: {
      const calendars = action.payload
      const primaryCalendar = getPrimaryCalendar(calendars)

      return {
        ...state,
        items: action.payload,
        primaryProvider: primaryCalendar.providerName,
        profileName: primaryCalendar.profileName
      }
    }
    case CALENDAR.PURGE_CALENDAR_DATA: {
      return initialState
    }
    default:
      return state
  }
}

export default reducer
